export const allCompanyPortfolio = {
    title: '技術ポートフォリオ分析',
    description:
        '企業間比較で指定した各企業の保有する出願特許の技術群（クラスタ）を全て表示しています。\nより全体を俯瞰して確認することができます。クラスタの配置はクラスタ＆バリューチェーンと同様にテーマ全体の動向を表す一方、バブルの大きさが各企業固有の数値（スコアなど）となっています。',
    displayColumn1: '1列で表示',
    displayColumn2: '2列で表示',
    company: '企業',
    xSelect1: 'スコア（技術の進展度）',
    ySelect1: '市場期待値',
    bubbleSelect1: 'スコア（技術競争力）',
    bubbleSelect2: '特許出願数',
    bubbleSelect3: '被引用数 （平均値）',
    copy: 'コピー',
    yAxisUnit: '(10億円)',
    labelArrayOverFlowMsg: '最大5つのラベルまで表示可能です',

    // 設定画面
    xLabel: 'X軸',
    yLabel: 'Y軸',
    setting: '設定',
    size: 'バブルの大きさ',
    zoomSlider: 'ズームスライダー',
    nonDisplay: '表示しない',
    initButton: '設定の初期化'
}
